module.exports = __webpack_public_path__ + "02_short_gray.cb99557e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/02_short_gray.png
// module id = 3wNq
// module chunks = 0